import { resetPluCallback, setPluCallback } from 'src/bottom-area/business-logic/handle-plu-items';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import { ISelectedItem } from 'src/common/interfaces/dtos/ISelectedItem';
import { ILineItemAddData } from 'src/items-list/business-logic/line-item-add';
import { restorePage } from '../../common/components/emerald-home-page/emerald-home-page';
import { PriceOverrideType } from '../../common/enumerations/price-override-type';
import { store } from '../../common/redux/configure-store';
import {
  IItemBuiltQuery,
  queryAndBuildLineItem,
} from '../../items-list/business-logic/query-and-build-line-item';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { priceOverrideWithOperation } from '../../price-override/business-logic/handle-price-override';
import { resetSalesKeypadState } from '../../sales-keypad/business-logic/sales-keypad-operations';
import {
  IPreSalePriceOverrideProps,
  showPreSalePriceOverride,
} from '../components/pre-sale-price-override';
import { convert } from '../mapper/item-lookup-converter';

export const initializePreSalePriceOverride = (): void => {
  const closePreSalePriceOverride = (): void => {
    resetPluCallback();
    restorePage();
  };

  const startPriceOverrideFlow = (lineItemAdd: ILineItemAddData): Promise<void> =>
    priceOverrideWithOperation(
      convert(lineItemAdd.itemLookup, lineItemAdd.lineItem),
      PriceOverrideType.Regular,
      lineItemAdd.lineItem,
      lineItemAdd.itemLookup,
    );

  const onScan = (itemCode: string): Promise<void> =>
    queryItemForPreSale(itemCode, EntryMethod.Scanned)
      .then(startPriceOverrideFlow)
      .then(closePreSalePriceOverride)
      .catch(popupMessage)
      .finally(resetSalesKeypadState);

  const pluCallback = (selectedItem?: ISelectedItem, itemId?: string): Promise<void> =>
    queryItemForPreSale(
      itemId ?? selectedItem?.selectedItemId ?? '',
      EntryMethod.Automatic,
      selectedItem,
    )
      .then(startPriceOverrideFlow)
      .then(closePreSalePriceOverride)
      .catch(popupMessage)
      .finally(resetSalesKeypadState);

  const onKeypadSubmit = (input: string): Promise<void> =>
    queryItemForPreSale(input, EntryMethod.Keyed)
      .then(startPriceOverrideFlow)
      .then(closePreSalePriceOverride)
      .catch(popupMessage);

  const props: IPreSalePriceOverrideProps = {
    onCancel: closePreSalePriceOverride,
    onKeypadSubmit,
  };

  setPluCallback(pluCallback);

  showPreSalePriceOverride(props, onScan);
};

export const queryItemForPreSale = (
  itemCode: string,
  entryMethod: EntryMethod,
  selectedItem?: ISelectedItem,
): Promise<ILineItemAddData> => {
  const { metricValue, isManualWeight } = store.getState().salesKeypad;
  const params: IItemBuiltQuery = {
    inputData: {
      itemId: itemCode,
      quantity: metricValue,
      isManualWeight,
      entryMethod: entryMethod,
    },
  };
  if (selectedItem) {
    params.itemLookup = {
      itemId: selectedItem.selectedItemId,
      unitsOfMeasure: selectedItem.unitOfMeasure,
      unitPrice: selectedItem.price,
      description: selectedItem.name,
    };
  }
  return queryAndBuildLineItem(params);
};
